const createPager = require('lib/more-results');

createPager('.older-posts-container', '.btn-load-more', {
    initialResults: window.NL.BlogPosts,
    initialPage: 0,
    pageSize: 6,
    resultTemplate: _.template($('#blog-post-paginated-result-template').html())
});


// WEBPACK FOOTER //
// ./assets/js/app/pages/blog-index.js